import Auth from '@aws-amplify/auth';
import Amplify from '@aws-amplify/core';
import hello from 'hellojs';
import installXylemKeycloak from '../api/auth/modules/xylemKeycloak';
const networks = {
    /* cSpell: disable */
    google: '255772732372-aqeibsvre3796tth9qmlpnin241hephm.apps.googleusercontent.com',
    /* cSpell: enable */
};
const options = {
    redirect_uri: '/oauth.html',
    response_type: 'token',
};
hello.init(networks, options);
installXylemKeycloak(hello);
function configureAppSyncAuth(userPoolWebClientId) {
    if (!userPoolWebClientId)
        throw new TypeError('Authentication must be configured');
    const config = {
        region: 'eu-west-1',
        userPoolId: process.env.VUE_APP_AUTH_USER_POOL,
        userPoolWebClientId,
        mandatorySignIn: true,
    };
    Amplify.configure({ Auth: config });
}
const clientIds = {
    signInId: process.env.VUE_APP_AUTH_SIGN_IN,
    signUpId: process.env.VUE_APP_AUTH_SIGN_UP,
};
export function getSignUpAuth() {
    configureAppSyncAuth(clientIds.signUpId);
    return Auth;
}
export function getSignInAuth() {
    configureAppSyncAuth(clientIds.signInId);
    return Auth;
}
export const unclaimedSessionLength = 2 * 60 * 60 * 1000; // two hours
export const hintApiKey = process.env.VUE_APP_API_KEYS_HINT;
